export default {"src":"/_next/static/media/usdc.fcbe1556.svg","height":2000,"width":2000,"blurWidth":0,"blurHeight":0};